<template>
  <div class="head-nav-container">
    <div class="wrapper d-f-b">
      <img
        class="logo"
        src="@/assets/images/layout/logo.png"
        :alt="meeting_title"
        @click="handelGoHome"
      />
      <div class="right d-f-b">
        <div class="nav d-f-b">
          <span @click="handelGoHome">首页</span>
          <span v-show="false" @click="handleGoMeeting">会议</span>
        </div>
        <div v-show="false" class="logout d-f-b">
          <img src="@/assets/images/layout/user.png" :alt="meeting_title" />
          退出
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { meeting_title } from '@/utils/constant'
import { useRoute, useRouter } from 'vue-router'
import type { Router, RouteLocationNormalizedLoaded } from 'vue-router'

export default defineComponent({
  setup() {
    const router: Router = useRouter()
    const route: RouteLocationNormalizedLoaded = useRoute()
    const handelGoHome = () => {
      if (route.name !== 'home') {
        router.push({
          name: 'home'
        })
      }
    }
    const handleGoMeeting = () => {
      // if (route.name !== 'meeting') {
      //   router.push({
      //     name: 'meeting'
      //   })
      // }
    }
    return {
      meeting_title,
      handelGoHome,
      handleGoMeeting
    }
  }
})
</script>

<style scoped lang="scss">
.head-nav-container {
  width: 100%;
  height: 80px;
  padding-top: 15px;
  box-sizing: border-box;
  .logo {
    cursor: pointer;
    width: 448px;
    height: 50px;
  }
  .right {
    width: 234px;
    color: #333;
    font-size: 16px;
    font-weight: 400;
    .nav {
      width: 100px;
      cursor: pointer;
    }
    .logout {
      cursor: pointer;
      width: 82px;
      img {
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>
